import React, { useEffect, useState } from "react";
import "./Header.scss";
import logo from "../../../../Assets/mainLogo.png";
import { IoPersonSharp, IoReloadCircle } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { IoMdArrowRoundBack } from "react-icons/io";
import {
  Accordion,
  Box,
  Button,
  Drawer,
  ListItemButton,
  Typography,
} from "@mui/material";
import { IoMenuOutline } from "react-icons/io5";
import CustomAvatar from "../../../../Vuexy/avatar";

const Header = ({ page, handleRefresh }) => {
  const [open, setOpen] = useState(false);
  const [allProfileData, setAllProfileData] = useState();

  const navigate = useNavigate();
  const location = useLocation();
  let HeaderName = JSON.parse(sessionStorage.getItem("catelogAlbumMasterName"));

  useEffect(() => {
    const storedProfileData = sessionStorage.getItem("profileData");
    if (storedProfileData) {
      setAllProfileData(JSON.parse(storedProfileData));
    }
  }, [open]);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const DrawerList = (
    <Box
      sx={{ width: 250, marginTop: "5px" }}
      role="presentation"
      onClick={() => toggleDrawer(false)}
    >
      <div
        style={{
          padding: "0px",
          display: "flex",
          flexDirection: "column",
          gap: "5px",
        }}
      >
        <div className="header_top_profile">
          <CustomAvatar
            skin="light"
            color="success"
            variant="rounded"
            sx={{ width: 42, height: 42 , borderRadius: 50 }}
            src={
              allProfileData?.ImagePath ||
              "https://media.istockphoto.com/id/1337144146/vector/default-avatar-profile-icon-vector.jpg?s=612x612&w=0&k=20&c=BIbFwuv7FxTWvh5S3vB6bkT0Qv8Vn8N5Ffseq84ClGI="
            }
          ></CustomAvatar>
          <div>
            <p style={{ margin: "0px", fontWeight: 600, fontSize: "14px" }}>
              {allProfileData?.firstname} {allProfileData?.lastname}
            </p>
            <p style={{ margin: "-2px 0px 0px 0px",fontSize: "12px" }}>
              {allProfileData?.UserID}
            </p>
          </div>
        </div>
        {/* <Accordion className="HeaderMenu_accordion">
          <ListItemButton
            onClick={() => {
              setOpen(false);
              navigate("/Profile");
            }}
          >
            <Typography className="HeaderMenu_Without_Sub">Profile</Typography>
          </ListItemButton>
        </Accordion> */}
        {/* <Accordion className="HeaderMenu_accordion">
          <ListItemButton
            onClick={() => {
              setOpen(false);
              navigate("/Oders");
            }}
          >
            <Typography className="HeaderMenu_Without_Sub">Orders</Typography>
          </ListItemButton>
        </Accordion> */}

        <Accordion className="HeaderMenu_accordion">
          <ListItemButton
            onClick={() => {
              setOpen(false);
              navigate("/support");
            }}
          >
            <Typography className="HeaderMenu_Without_Sub">Support</Typography>
          </ListItemButton>
        </Accordion>

        <Accordion className="HeaderMenu_accordion">
          <ListItemButton
            onClick={() => {
              setOpen(false);
              navigate("/privacy-policy");
            }}
          >
            <Typography className="HeaderMenu_Without_Sub">
              Privacy Policy
            </Typography>
          </ListItemButton>
        </Accordion>

        <p className="versionText">V 1.0.1</p>
      </div>
    </Box>
  );

  return (
    <div>
      {[
        "/CrmDetail",
        "/Oders",
        "/OdersDetail",
        "/Profile",
        "/CatelogingDetail",
        "/NewCustomer",
        "/CatelogingShare",
        "/support",
        "/steps-account-delete",
        "/privacy-policy",
      ].includes(location.pathname) ? (
        <div className="headerMain_Page">
          <Button className="back_Button" onClick={() => navigate(-1)}>
            <IoMdArrowRoundBack
              style={{ color: "white", height: "30px", width: "30px" }}
            />
          </Button>
          <p
            style={{
              color: "white",
              width: "80%",
              fontWeight: 600,
              fontSize: "18px",
              margin: '0px'
            }}
          >
            {location.pathname == "/Oders"
              ? "Order"
              : location.pathname == "/OdersDetail"
              ? "Order Details"
              : location.pathname == "/steps-account-delete"
              ? "Delete Account Step"
              : location.pathname == "/privacy-policy"
              ? "Privacy Policy"
              : location.pathname == "/support"
              ? "Support"
              : location.pathname == "/CatelogingShare"
              ? `${HeaderName}`
              : location.pathname == "/NewCustomer"
              ? `${HeaderName}`
              : location.pathname == "/CatelogingDetail"
              ? "Cataloging Details"
              : location.pathname == "/Profile"
              ? "Profile"
              : location.pathname == "/CrmDetail"
              ? "CRM Details"
              : page}
          </p>
        </div>
      ) : location.pathname === "/Ledger" ? (
        <div className="headerMain_Crm">
          <Button className="back_Button" onClick={() => navigate(-1)}>
            <IoMdArrowRoundBack
              style={{ color: "white", height: "30px", width: "30px" }}
            />
          </Button>
          <p style={{ color: "white", fontWeight: 600, fontSize: "18px" }}>
            Ledger
          </p>
        </div>
      ) : (
        <div className="headerMain">
          <div style={{ marginLeft: "10px", width: "33.33%" }}>
            <IoMenuOutline
              style={{ height: "25px", width: "25px", color: "white" }}
              onClick={toggleDrawer(true)}
            />
          </div>
          <div
            style={{
              marginLeft: "0px",
              display: "flex",
              width: "33.33%",
              justifyContent: "center",
            }}
          >
            {location.pathname === "/Profile" ? (
              <FaHome
                style={{ height: "25px", width: "25px", color: "white" }}
                onClick={() => navigate("/")}
              />
            ) : (
              <img src={logo} alt="Logo" className="header_logo" />
            )}
          </div>
          {location.pathname !== "/Profile" && (
            <div
              style={{
                marginRight: "10px",
                display: "flex",
                alignItems: "center",
                width: "33.33%",
                justifyContent: "flex-end",
              }}
            >
              {location.pathname === "/Crm" ? (
                ""
              ) : (
                <Button className="refreshBtn">
                  <IoReloadCircle
                    style={{ height: "30px", width: "30px", color: "white" }}
                    onClick={handleRefresh}
                  />
                </Button>
              )}

              <IoPersonSharp
                style={{ height: "25px", width: "25px", color: "white" }}
                onClick={() => navigate("/Profile")}
              />
            </div>
          )}
        </div>
      )}
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
};

export default Header;
